// Deliberately unguessable admin URLs.
//
// These are NOT dictionary words like "login" / "dashboard", on purpose —
// the goal is that nobody can find the admin panel by typing common paths.
//
// IMPORTANT: this only hides the *existence* of the pages from casual
// browsing/bots. It is not real access control by itself — someone who
// somehow learns one of these strings (browser history, a leaked link,
// referrer header, etc.) could still open the page. The actual security
// still comes from:
//   - the email+password+OTP login flow (adminAuth.js)
//   - the JWT check in requireAdmin.js on every admin API route
//   - ProtectedRoute below, which bounces to the login page if there's
//     no adminToken in localStorage
//
// If you ever suspect one of these paths has leaked, just generate a new
// random string (e.g. `require('crypto').randomBytes(8).toString('hex')`
// in Node, or any password generator) and swap the value below — nothing
// else needs to change since every file imports from here.

export const ADMIN_LOGIN_PATH = "/d69be3b62140bae2";
export const ADMIN_DASHBOARD_PATH = "/776f90c44278e35d"; // ads / garland / grocery / courier hub
export const ADMIN_ITEMS_PATH = "/b26dc0c5361449e3"; // vegetables & flowers items list (its own page)
export const ADMIN_MOBILE_PATH = "/jabir-mobilesacess-356sjmasec123"; // mobile accessories management